// dom
import {
	body
} from 'iblokz-snabbdom-helpers';
// components
import header from './header';
import layout from './layout';

export default ({state, actions, i18n}) => body([
	header({ state, actions, i18n }),
	layout({ state, actions, i18n }),
]);
